/* tslint:disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpRequest, HttpResponse, HttpHeaders } from '@angular/common/http';
import { BaseService as __BaseService } from '../base-service';
import { WebConfiguration as __Configuration } from '../web-configuration';
import { StrictHttpResponse as __StrictHttpResponse } from '../strict-http-response';
import { Observable as __Observable } from 'rxjs';
import { map as __map, filter as __filter } from 'rxjs/operators';

import { PreInvoiceList } from '../models/pre-invoice-list';
import { PreInvoiceSearchOptions } from '../models/pre-invoice-search-options';
@Injectable({
  providedIn: 'root',
})
class PreInvoiceService extends __BaseService {
  static readonly retrieveDeliveryPreInvoicePath = '/preinvoices/search';
  static readonly exportPreInvoicesPath = '/preinvoices/export';

  constructor(
    config: __Configuration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Retrieve the pre invoices of deliveries
   *
   * Retrieve the preinvoices of deliveries
   * @param params The `PreInvoiceService.RetrieveDeliveryPreInvoiceParams` containing the following parameters:
   *
   * - `date`: Month Date YYYY-MM
   *
   * - `search`: The preinvoice search options object
   *
   * @return Success
   */
  retrieveDeliveryPreInvoiceResponse(params: PreInvoiceService.RetrieveDeliveryPreInvoiceParams): __Observable<__StrictHttpResponse<PreInvoiceList>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (params.date != null) __params = __params.set('date', params.date.toString());
    __body = params.search;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/preinvoices/search`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<PreInvoiceList>;
      })
    );
  }
  /**
   * Retrieve the pre invoices of deliveries
   *
   * Retrieve the preinvoices of deliveries
   * @param params The `PreInvoiceService.RetrieveDeliveryPreInvoiceParams` containing the following parameters:
   *
   * - `date`: Month Date YYYY-MM
   *
   * - `search`: The preinvoice search options object
   *
   * @return Success
   */
  retrieveDeliveryPreInvoice(params: PreInvoiceService.RetrieveDeliveryPreInvoiceParams): __Observable<PreInvoiceList> {
    return this.retrieveDeliveryPreInvoiceResponse(params).pipe(
      __map(_r => _r.body as PreInvoiceList)
    );
  }

  /**
   * Export PreInvoices with delivery details
   *
   * Export preinvoices with delivery details
   * @param params The `PreInvoiceService.ExportPreInvoicesParams` containing the following parameters:
   *
   * - `date`: Month Date YYYY-MM
   *
   * - `search`: The preinvoice search options object
   *
   * @return Success
   */
  exportPreInvoicesResponse(params: PreInvoiceService.ExportPreInvoicesParams): __Observable<__StrictHttpResponse<Blob>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (params.date != null) __params = __params.set('date', params.date.toString());
    __body = params.search;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/preinvoices/export`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'blob'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Blob>;
      })
    );
  }
  /**
   * Export PreInvoices with delivery details
   *
   * Export preinvoices with delivery details
   * @param params The `PreInvoiceService.ExportPreInvoicesParams` containing the following parameters:
   *
   * - `date`: Month Date YYYY-MM
   *
   * - `search`: The preinvoice search options object
   *
   * @return Success
   */
  exportPreInvoices(params: PreInvoiceService.ExportPreInvoicesParams): __Observable<Blob> {
    return this.exportPreInvoicesResponse(params).pipe(
      __map(_r => _r.body as Blob)
    );
  }
}

namespace PreInvoiceService {

  /**
   * Parameters for retrieveDeliveryPreInvoice
   */
  export interface RetrieveDeliveryPreInvoiceParams {

    /**
     * Month Date YYYY-MM
     */
    date: string;

    /**
     * The preinvoice search options object
     */
    search?: PreInvoiceSearchOptions;
  }

  /**
   * Parameters for exportPreInvoices
   */
  export interface ExportPreInvoicesParams {

    /**
     * Month Date YYYY-MM
     */
    date: string;

    /**
     * The preinvoice search options object
     */
    search?: PreInvoiceSearchOptions;
  }
}

export { PreInvoiceService }
